import { Component, OnInit } from '@angular/core';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { Users } from 'src/app/models/um/organization';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Subject } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-to-bcc',
  templateUrl: './to-bcc.component.html',
  styleUrls: ['./to-bcc.component.scss']
})
export class ToBccComponent implements OnInit {

  constructor(
    public modalRef: NgbActiveModal,
    private summaryService: UmSummaryService,
    private modalService: NgbModal,
  )
  { }

  action: Subject<any> = new Subject();
  heading: string;
  rowData: Users[];
  user;
  filterData: Users[];
  changedusers: Users[];
  content: any;
  selectedusers: Users[];

  ngOnInit() {
    if (this.content) {
      this.selectedusers = this.content;
    }

    this.setSummary("-1");
  }

  setSummary(filter) {
    this.summaryService.getUserSummary(filter).subscribe(summary => {
      if (summary && this.selectedusers) {
        let len = summary.length;
        let slen = this.selectedusers.length;

        for (let i = 0; i < len; i++) {
          for (let j = 0; j < slen; j++) {
            if (summary[i].EMAIL === this.selectedusers[j]) {
              summary[i].isChecked = true;
            }
          }
        }
      }

      this.rowData = summary;
      this.filterData = summary;
    });
  }

  onChangeEvent(event: any) {
    this.rowData = this.filterData.filter(
      user => user.FIRST_NAME.toLowerCase().includes(event.target.value.toLowerCase()) || user.isChecked === true);
  }

  save() {
    this.changedusers = [] as any;;
    let selected = [];
    const len = this.filterData.length;
    for (let i = 0; i < len; i++) {
      if (this.filterData[i].isChecked) {
        this.user = this.filterData[i];
        selected.push(i);

        this.changedusers.push(this.filterData[i]);
      }
    }

    //if (selected.length == 0) {
    //  this.modalService.show(MessageBoxComponent, { data: { heading: 'Add Roles', content: { heading: '', description: "Plesae Select Users." } } });
    //  return;
    //}
    //else {
     // this.action.next(this.changedusers);
      this.modalRef.close(this.changedusers);
    //}
  }
}
